import React from 'react';
import { signOff, meta } from '../data/caseStudy';
export function SignOff() {
  return <footer id="sign-off" className="w-full bg-ink text-white" data-id="element-128" data-mp="1onffglz6vpae">
      <div className="h-[6px] w-full accent-rule" aria-hidden="true" data-id="element-129" data-mp="1op09mahld67q" />
      <div className="mx-auto w-[1200px] px-24 py-20" data-id="element-130" data-mp="22ldp5e2kexjk">
        <div className="grid grid-cols-4 gap-10" data-id="element-131" data-mp="1xnu3vu7g9ki4">
          {signOff.map(item => <div key={item.label} data-id="element-132" data-mp="19xzslh2s43zz">
              <p className="font-display text-[52px] font-bold leading-none tracking-tightest accent-text" data-id="element-133" data-mp="19z1eyhp8wcx0">
                {item.value}
              </p>
              <p className="mt-4 font-display text-[11px] font-semibold uppercase tracking-[0.24em] text-white/60" data-id="element-134" data-mp="15ulamkva5djw">
                {item.label}
              </p>
            </div>)}
        </div>

        <div className="mt-20 flex items-baseline justify-between border-t border-white/15 pt-8" data-id="element-135" data-mp="r7ibyav80yuz">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.24em] text-white/60" data-id="element-136" data-mp="m8f5clzlekkw">
            {meta.client} / {meta.timeline}
          </p>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.24em] text-white/40" data-id="element-137" data-mp="3mdeqdn0ih9ag">
            Nektaria Bogris
          </p>
        </div>
      </div>
    </footer>;
}